<span class="__dimensions_badge_embed__" data-style="small_circle" data-legend="hover-bottom"
      [attr.data-doi]="doi"></span>
<span data-badge-type="donut" class='altmetric-embed'
      [attr.data-doi]="doi"></span>
